module.exports = __webpack_public_path__ + "img/linkIcon.d14398a6.svg";